<template>
  <div class="faq-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">FAQ</span>
        <span class="page-subtitle">Frequently asked questions</span>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-state" v-if="loading">
      <div class="spinner"></div>
      <span>Loading…</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" v-if="!loading && activeFaqs.length === 0">
      <div class="empty-icon-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <p class="empty-title">No FAQs available</p>
      <p class="empty-sub">Check back later for answers to common questions.</p>
    </div>

    <!-- FAQ accordion -->
    <div class="section-pad" v-if="!loading && activeFaqs.length > 0">
      <p class="section-label">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        {{ activeFaqs.length }} question{{ activeFaqs.length !== 1 ? 's' : '' }}
      </p>

      <div class="accordion">
        <div
          class="faq-item"
          v-for="(faq, index) in activeFaqs"
          :key="faq.id"
          :class="{ 'faq-item--open': openId === faq.id }"
        >
          <button class="faq-trigger" @click="toggle(faq.id)">
            <span class="faq-number">{{ String(index + 1).padStart(2, '0') }}</span>
            <span class="faq-question">{{ faq.title }}</span>
            <span class="faq-chevron">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </span>
          </button>

          <transition
            name="expand"
            @enter="onEnter"
            @after-enter="onAfterEnter"
            @leave="onLeave"
          >
            <div class="faq-body" v-if="openId === faq.id">
              <p class="faq-answer">{{ faq.body }}</p>
            </div>
          </transition>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'faq',
  data: function () {
    return {
      faqs: [],
      loading: true,
      openId: null
    }
  },
  computed: {
    activeFaqs: function () {
      return this.faqs.filter(function (f) { return f.enabled == 1 })
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    var that = this

    $.ajax({
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
      },
      url: 'https://admin.medicater.co.za/api/basic/faqs',
      type: 'post',
      success: function (data) {
        that.loading = false
        that.faqs = data.data
      },
      error: function (data) {
        that.loading = false
        if (window.localStorage.getItem(this.url)) {
          var offlineData = JSON.parse(window.localStorage.getItem(this.url))
          that.faqs = offlineData.data || []
        } else {
          swal({ text: 'Please connect to the internet', icon: 'info', button: 'Ok' })
        }
      }
    })
  },
  methods: {
    toggle: function (id) {
      this.openId = this.openId === id ? null : id
    },
    onEnter: function (el) {
      el.style.height = '0'
      el.style.overflow = 'hidden'
      el.offsetHeight // force reflow
      el.style.transition = 'height 0.28s ease'
      el.style.height = el.scrollHeight + 'px'
    },
    onAfterEnter: function (el) {
      el.style.height = 'auto'
      el.style.overflow = ''
    },
    onLeave: function (el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.overflow = 'hidden'
      el.offsetHeight
      el.style.transition = 'height 0.24s ease'
      el.style.height = '0'
    }
  }
}
</script>

<style scoped>
.faq-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255, 255, 255, 0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; }

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

/* ── Loading ── */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 120px 16px 40px;
  color: #94a3b8;
  font-size: 0.875rem;
}

.spinner {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #1a587b;
  border-left-color: #1a587b;
  animation: spin 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}
.spinner::after {
  content: '';
  position: absolute;
  inset: 5px;
  border-radius: 50%;
  border: 2.5px solid transparent;
  border-top-color: rgba(26, 88, 123, 0.35);
  border-left-color: rgba(26, 88, 123, 0.35);
  animation: spin 1.8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite reverse;
}

@keyframes spin { to { transform: rotate(360deg); } }

/* ── Empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 120px 32px 40px;
  text-align: center;
}

.empty-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a587b;
  margin-bottom: 4px;
}

.empty-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.empty-sub {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0;
}

/* ── Section ── */
.section-pad {
  padding: 110px 16px 0;
  max-width: 700px;
  margin: 0 auto;
}

.section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #64748b;
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ── Accordion ── */
.accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.faq-item {
  background: #fff;
  border-radius: 14px;
  border: 1.5px solid #e8edf2;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.faq-item--open {
  border-color: #1a587b;
  box-shadow: 0 4px 18px rgba(26, 88, 123, 0.12);
}

.faq-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
}
.faq-trigger:hover { background: #f8fafc; }

.faq-number {
  font-size: 0.65rem;
  font-weight: 800;
  color: #1a587b;
  background: #e0f2fe;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.5px;
}

.faq-item--open .faq-number {
  background: #1a587b;
  color: #fff;
}

.faq-question {
  flex: 1;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
}

.faq-item--open .faq-question {
  color: #1a587b;
}

.faq-chevron {
  flex-shrink: 0;
  color: #94a3b8;
  display: flex;
  align-items: center;
  transition: transform 0.25s ease;
}

.faq-item--open .faq-chevron {
  transform: rotate(180deg);
  color: #1a587b;
}

/* ── Answer body ── */
.faq-body {
  border-top: 1px solid #f1f5f9;
}

.faq-answer {
  padding: 16px 18px 18px 58px;
  font-size: 0.875rem;
  color: #475569;
  line-height: 1.65;
  margin: 0;
}
</style>
